(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lca-demo-videos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot(root) {
    if (!root || root.dataset.lcaDemoReady === 'true') return;
    var track = root.querySelector('[data-demo-track]');
    var prev = root.querySelector('[data-demo-prev]');
    var next = root.querySelector('[data-demo-next]');
    if (!track) return;
    root.dataset.lcaDemoReady = 'true';

    function slides() {
      return track.querySelectorAll('[data-demo-slide]');
    }

    function perView() {
      if (window.matchMedia('(min-width: 1200px)').matches) return 5;
      if (window.matchMedia('(min-width: 750px)').matches) return 4;
      return 1;
    }

    function update() {
      var count = slides().length;
      var hideNav = count <= perView();
      root.classList.toggle('is-static', hideNav);
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = hideNav || track.scrollLeft <= 2;
      if (next) next.disabled = hideNav || track.scrollLeft >= max - 2;
    }

    function step(direction) {
      var slide = slides()[0];
      if (!slide) return;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 16;
      track.scrollBy({
        left: direction * (slide.getBoundingClientRect().width + gap),
        behavior: 'smooth'
      });
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    root.addEventListener('play', function (event) {
      if (!event.target || event.target.tagName !== 'VIDEO') return;
      root.querySelectorAll('video').forEach(function (video) {
        if (video !== event.target) video.pause();
      });
    }, true);
    update();
  }

  function bootAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll('[data-lca-demo]').forEach(boot);
  }

  bootAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    bootAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lca-footer"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.lcaHomepageReady) return;
  window.lcaHomepageReady = true;
  let previousFocus = null;
  const root = document;
  function close(dialog) { dialog.close(); document.body.style.overflow = ''; previousFocus?.focus({preventScroll:true}); }
  function appSetup() {
    const banner=root.getElementById('app-banner'), link=root.getElementById('smart-app-link');
    if (!banner || !link) return;
    const android=root.querySelector('.app-store-links a[href*="play.google.com"]');
    const ios=root.querySelector('.app-store-links a[href*="apps.apple.com"]');
    const isIos=/iPad|iPhone|iPod/i.test(navigator.userAgent)||(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1);
    link.href=/Android/i.test(navigator.userAgent)&&android?android.href:isIos&&ios?ios.href:'#download-app';
    try { const date=Number(localStorage.getItem('lca-app-banner-dismissed')); if(date>0&&Date.now()-date<604800000&&!window.Shopify?.designMode)banner.hidden=true; } catch (_) {}
  }
  function renderSearch() {
    const input=root.getElementById('product-search'),results=root.getElementById('search-results');
    if(!input||!results)return;
    const cards=[...new Map([...root.querySelectorAll('.product-card')].map(card=>[card.dataset.handle,card])).values()];
    const matches=cards.filter(card=>card.dataset.search.includes(input.value.trim().toLowerCase())).slice(0,6);
    results.replaceChildren();
    for(const card of matches){const a=document.createElement('a');a.className='search-result';a.href=card.querySelector('.product-name a').href;const img=card.querySelector('.product-image img');if(img)a.append(img.cloneNode());const text=document.createElement('span');const name=document.createElement('strong');name.textContent=card.querySelector('.product-name').textContent;const price=document.createElement('small');price.textContent=card.querySelector('.current-price').textContent;text.append(name,price);a.append(text);results.append(a);}
  }
  root.addEventListener('click',event=>{
    const opener=event.target.closest('[data-open]');
    if(opener){const dialog=root.getElementById(opener.dataset.open);if(dialog){previousFocus=opener;dialog.showModal();document.body.style.overflow='hidden';if(dialog.id==='search-dialog'){renderSearch();root.getElementById('product-search').focus();}}return;}
    const closer=event.target.closest('[data-close],[data-close-link]');if(closer){const dialog=closer.closest('dialog');if(dialog)close(dialog);}
    if(event.target.matches('dialog')){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)close(event.target);}
    const dismiss=event.target.closest('#app-dismiss');if(dismiss){root.getElementById('app-banner').hidden=true;try{localStorage.setItem('lca-app-banner-dismissed',String(Date.now()));}catch(_){}root.querySelector('.brand')?.focus({preventScroll:true});}
    const filter=event.target.closest('[data-filter]');if(filter){const section=filter.closest('section');section.querySelectorAll('[data-filter]').forEach(button=>{const active=button===filter;button.classList.toggle('active',active);button.setAttribute('aria-pressed',String(active));});const value=filter.dataset.filter;let count=0;section.querySelectorAll('.product-card').forEach(card=>{const show=value==='all'?card.dataset.bestseller==='true':value==='budget'?Number(card.dataset.price)<1000:card.dataset.categories.split(' ').includes(value);card.hidden=!show;if(show)count++;});const status=root.getElementById('filter-status');if(status)status.textContent=count+' · '+filter.textContent;}
  });
  root.addEventListener('input',event=>{if(event.target.id==='product-search')renderSearch();});
  root.addEventListener('close',event=>{if(event.target.matches('dialog')){document.body.style.overflow='';previousFocus?.focus({preventScroll:true});}},true);
  root.addEventListener('shopify:section:load',()=>{appSetup();renderSearch();});
  root.addEventListener('shopify:block:select',event=>{const card=event.target.closest('.product-card');if(card)card.hidden=false;});
  if(document.readyState==='loading')root.addEventListener('DOMContentLoaded',appSetup);else appSetup();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lca-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  function setup(root) {
    root.querySelectorAll('[data-lca-campaign]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const track = section.querySelector('.campaign-track');
      const slides = [...section.querySelectorAll('.campaign-slide')];
      const tabs = [...section.querySelectorAll('[data-campaign-index]')];
      let active = 0, queued = false;
      function go(index, smooth = true) {
        const slide = slides[Math.max(0, Math.min(slides.length - 1, index))];
        if (!slide) return;
        track.scrollTo({left: slide.offsetLeft - slides[0].offsetLeft, behavior: smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant'});
      }
      function sync() {
        const left = track.getBoundingClientRect().left;
        let nearest = Infinity;
        slides.forEach((slide, index) => {
          const delta = Math.abs(slide.getBoundingClientRect().left - left);
          if (delta < nearest) { nearest = delta; active = index; }
        });
        tabs.forEach((tab, index) => tab.setAttribute('aria-pressed', String(index === active)));
        section.querySelectorAll('[data-campaign-step]').forEach(button => {
          button.disabled = Number(button.dataset.campaignStep) < 0 ? active === 0 : active === slides.length - 1;
        });
        queued = false;
      }
      section.addEventListener('click', event => {
        const tab = event.target.closest('[data-campaign-index]');
        const arrow = event.target.closest('[data-campaign-step]');
        if (tab) go(Number(tab.dataset.campaignIndex));
        if (arrow) go(active + Number(arrow.dataset.campaignStep));
      });
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); go(active + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      track.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(sync); } }, {passive: true});
      section.addEventListener('shopify:block:select', event => {
        const selected = event.target.closest('.campaign-slide');
        if (selected) go(slides.indexOf(selected), false);
      });
      sync();
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lca-home-utilities"]) return;
  try {
    
(() => {
  if (window.lcaLaunchHelpReady) return;
  window.lcaLaunchHelpReady = true;
  let previousFocus;
  document.addEventListener('click',event => {
    const container=document.getElementById('lca-home-content');
    if (!container?.contains(event.target)) return;
    const dialog=container.querySelector('#support-dialog');
    if (!dialog) return;
    if (event.target.closest('[data-open="support-dialog"]')) {previousFocus=event.target.closest('button,a');dialog.showModal();return;}
    if (event.target.closest('[data-close],[data-close-link]')) dialog.close();
  });
  document.addEventListener('close',event=>{if(event.target.id==='support-dialog')previousFocus?.focus({preventScroll:true});},true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lca-product-footer"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.lcaHomepageReady) return;
  window.lcaHomepageReady = true;
  let previousFocus = null;
  const root = document;
  function close(dialog) { dialog.close(); document.body.style.overflow = ''; previousFocus?.focus({preventScroll:true}); }
  function appSetup() {
    const banner=root.getElementById('app-banner'), link=root.getElementById('smart-app-link');
    if (!banner || !link) return;
    const android=root.querySelector('.app-store-links a[href*="play.google.com"]');
    const ios=root.querySelector('.app-store-links a[href*="apps.apple.com"]');
    const isIos=/iPad|iPhone|iPod/i.test(navigator.userAgent)||(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1);
    link.href=/Android/i.test(navigator.userAgent)&&android?android.href:isIos&&ios?ios.href:'#download-app';
    try { const date=Number(localStorage.getItem('lca-app-banner-dismissed')); if(date>0&&Date.now()-date<604800000&&!window.Shopify?.designMode)banner.hidden=true; } catch (_) {}
  }
  function renderSearch() {
    const input=root.getElementById('product-search'),results=root.getElementById('search-results');
    if(!input||!results)return;
    const cards=[...new Map([...root.querySelectorAll('.product-card')].map(card=>[card.dataset.handle,card])).values()];
    const matches=cards.filter(card=>card.dataset.search.includes(input.value.trim().toLowerCase())).slice(0,6);
    results.replaceChildren();
    for(const card of matches){const a=document.createElement('a');a.className='search-result';a.href=card.querySelector('.product-name a').href;const img=card.querySelector('.product-image img');if(img)a.append(img.cloneNode());const text=document.createElement('span');const name=document.createElement('strong');name.textContent=card.querySelector('.product-name').textContent;const price=document.createElement('small');price.textContent=card.querySelector('.current-price').textContent;text.append(name,price);a.append(text);results.append(a);}
  }
  root.addEventListener('click',event=>{
    const opener=event.target.closest('[data-open]');
    if(opener){const dialog=root.getElementById(opener.dataset.open);if(dialog){previousFocus=opener;dialog.showModal();document.body.style.overflow='hidden';if(dialog.id==='search-dialog'){renderSearch();root.getElementById('product-search').focus();}}return;}
    const closer=event.target.closest('[data-close],[data-close-link]');if(closer){const dialog=closer.closest('dialog');if(dialog)close(dialog);}
    if(event.target.matches('dialog')){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)close(event.target);}
    const dismiss=event.target.closest('#app-dismiss');if(dismiss){root.getElementById('app-banner').hidden=true;try{localStorage.setItem('lca-app-banner-dismissed',String(Date.now()));}catch(_){}root.querySelector('.brand')?.focus({preventScroll:true});}
    const filter=event.target.closest('[data-filter]');if(filter){const section=filter.closest('section');section.querySelectorAll('[data-filter]').forEach(button=>{const active=button===filter;button.classList.toggle('active',active);button.setAttribute('aria-pressed',String(active));});const value=filter.dataset.filter;let count=0;section.querySelectorAll('.product-card').forEach(card=>{const show=value==='all'?card.dataset.bestseller==='true':value==='budget'?Number(card.dataset.price)<1000:card.dataset.categories.split(' ').includes(value);card.hidden=!show;if(show)count++;});const status=root.getElementById('filter-status');if(status)status.textContent=count+' · '+filter.textContent;}
  });
  root.addEventListener('input',event=>{if(event.target.id==='product-search')renderSearch();});
  root.addEventListener('close',event=>{if(event.target.matches('dialog')){document.body.style.overflow='';previousFocus?.focus({preventScroll:true});}},true);
  root.addEventListener('shopify:section:load',()=>{appSetup();renderSearch();});
  root.addEventListener('shopify:block:select',event=>{const card=event.target.closest('.product-card');if(card)card.hidden=false;});
  if(document.readyState==='loading')root.addEventListener('DOMContentLoaded',appSetup);else appSetup();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lca-product-main"] && !Shopify.designMode) return;
  try {
    
(() => {
  function setup(root) {
    root.querySelectorAll('[data-lca-product]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const track = section.querySelector('.pdp-image-track');
      const slides = [...track.querySelectorAll('.pdp-image-slide')];
      const thumbs = [...section.querySelectorAll('[data-gallery-target]')];
      let frame = false;
      function move(slide) {
        if (slide && slides.length) track.scrollTo({left: slide.offsetLeft - slides[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
      thumbs.forEach(button => button.addEventListener('click', () => move(document.getElementById(button.dataset.galleryTarget))));
      track.addEventListener('scroll', () => {
        if (frame || !slides.length) return;
        frame = true;
        requestAnimationFrame(() => {
          const left = track.getBoundingClientRect().left;
          const nearest = slides.reduce((a,b) => Math.abs(a.getBoundingClientRect().left-left) < Math.abs(b.getBoundingClientRect().left-left) ? a : b);
          thumbs.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.galleryTarget === nearest.id)));
          slides.forEach(slide => { if (slide !== nearest) slide.querySelectorAll('video').forEach(video => video.pause()); });
          frame = false;
        });
      }, {passive:true});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const active = thumbs.findIndex(button => button.getAttribute('aria-pressed') === 'true');
        move(slides[Math.max(0,Math.min(slides.length-1,active+(event.key === 'ArrowRight' ? 1 : -1)))]);
      });
      section.addEventListener('shopify:block:select', event => move(event.target.closest('.pdp-image-slide')));

      const form = section.querySelector('.pdp-product-form');
      if (!form) return;
      const select = form.querySelector('[data-variant-select]');
      const variants = [...select.options].map(option => ({id:option.value, option, ...option.dataset, options:JSON.parse(option.dataset.options)}));
      const optionInputs = [...form.querySelectorAll('[data-option-index]')];
      const add = section.querySelector('[data-pdp-add]');
      const sticky = section.querySelector('[data-pdp-sticky-add]');
      const buy = section.querySelector('[data-pdp-buy]');
      const offer = section.querySelector('[data-offer]');
      const stickyCompare = section.querySelector('[data-sticky-compare]');
      const qty = form.querySelector('[name="quantity"]');
      const unavailableLabel = section.querySelector('[data-unavailable-label]').textContent;
      const error = form.querySelector('[data-form-error]');
      let current = variants.find(variant => variant.id === select.value);
      let busy = false;
      const addon = form.querySelector('[data-addon-select]');
      const money = new Intl.NumberFormat(document.documentElement.lang === 'en' ? 'en-IN' : document.documentElement.lang, {style:'currency', currency:section.dataset.currency});
      function paintButtons() {
        const available = current?.variantAvailable === 'true';
        const label = busy ? section.querySelector('[data-adding-label]').textContent : !current ? unavailableLabel : available ? add.dataset.addLabel : add.dataset.soldOutLabel;
        add.disabled = sticky.disabled = busy || !available;
        add.textContent = sticky.textContent = label;
        if (buy) {buy.hidden = false;buy.disabled = busy || !available;buy.textContent = busy || !available ? label : buy.dataset.label;}
      }
      function updateAddon() {
        if (!addon) return;
        const selected = addon.selectedOptions[0];
        const enabled = Boolean(selected?.value);
        if (stickyCompare) stickyCompare.hidden = enabled || !current?.variantCompare;
        section.querySelector('[data-sticky-price]').textContent = current?.variantPrice || '—';
        section.querySelector('[data-sticky-variant]').textContent = current?.variantTitle || '';
        const panel = form.querySelector('[data-addon-panel]');
        panel.hidden = false;
        panel.querySelector('[data-addon-preview]').hidden = !enabled;
        panel.querySelector('[data-addon-timing]').hidden = !enabled;
        const goldNote = panel.querySelector('[data-gold-note]');
        if (goldNote) goldNote.hidden = !enabled || !(selected?.dataset.metal || '').includes('gold');
        const ring = panel.querySelector('[data-ring-size]');
        ring.hidden = !enabled || selected?.dataset.wear !== 'ring';
        ring.querySelector('input').disabled = ring.hidden;
        const gemCents = Number(current?.priceCents || 0);
        const addonCents = enabled ? Number(selected.dataset.priceCents || 0) : 0;
        const totalEl = panel.querySelector('[data-addon-total]');
        if (current && totalEl) {
          const total = money.format((gemCents + addonCents) / 100);
          panel.querySelector('[data-total-price]').textContent = total;
          totalEl.hidden = false;
          totalEl.dataset.priceCents = String(gemCents + addonCents);
          const currentPrice = section.querySelector('[data-current-price]');
          if (currentPrice) currentPrice.textContent = total;
          if (enabled) {
            section.querySelector('[data-sticky-price]').textContent = total;
            section.querySelector('[data-sticky-variant]').textContent = selected.dataset.title || '';
          }
        } else if (totalEl) {
          totalEl.hidden = true;
        }
        if (enabled) {
          panel.querySelector('[data-addon-title]').textContent = selected.dataset.title;
          panel.querySelector('[data-addon-price]').textContent = selected.dataset.price;
          const slot = panel.querySelector('[data-addon-image-slot]');
          slot.replaceChildren();
          if (selected.dataset.image) {
            const photo = document.createElement('img');
            photo.src = selected.dataset.image; photo.alt = selected.dataset.title;
            photo.width = photo.height = 160; photo.loading = 'lazy'; slot.append(photo);
          }
        }
      }
      function updateAvailability() {
        const chosen = [];
        optionInputs.filter(input => input.checked).forEach(input => { chosen[Number(input.dataset.optionIndex)] = input.value; });
        optionInputs.forEach(input => {
          const index = Number(input.dataset.optionIndex);
          const match = variants.find(variant => variant.options.every((value,i) => value === (i === index ? input.value : chosen[i])));
          const status = input.closest('label').querySelector('[data-option-status]');
          status.textContent = !match ? unavailableLabel : match.variantAvailable === 'true' ? '' : add.dataset.soldOutLabel;
          input.closest('label').classList.toggle('pdp-option-unavailable', !match || match.variantAvailable !== 'true');
        });
      }
      function updateVariant(variant, updateUrl) {
        current = variant;
      if (offer) {
  const difference =
    Number(variant?.compareCents || 0) -
    Number(variant?.priceCents || 0);

  const badge = offer.querySelector('[data-offer-percent]');
  const saving = offer.querySelector('[data-offer-saving]');

  if (badge) {
    badge.textContent =
      difference > 0
        ? badge.dataset.label.replace(
            '[percent]',
            String(
              Math.floor(
                difference * 100 / Number(variant.compareCents)
              )
            )
          )
        : '';
  }

 if (saving) {
  saving.textContent = 'Already applied';
}
}
        if (stickyCompare) {stickyCompare.textContent = variant?.variantCompare || '';stickyCompare.hidden = !variant?.variantCompare;}
        const photo = section.querySelector('.pdp-sticky-image');
        if (photo && variant?.variantImage) {photo.src = variant.variantImage;photo.removeAttribute('srcset');}

        select.value = variant?.id || '';
        select.disabled = !variant;
        section.querySelector('[data-current-price]').textContent = variant?.variantPrice || '—';
        section.querySelector('[data-sticky-price]').textContent = variant?.variantPrice || '—';
        section.querySelector('[data-sticky-variant]').textContent = variant?.variantTitle || '';
        section.querySelector('[data-selected-variant]').textContent = variant?.variantTitle || '';
        for (const [selector,key] of [['[data-compare-price]','variantCompare'],['[data-saving]','variantSaving']]) {
          const element = section.querySelector(selector); element.textContent = variant?.[key] || ''; element.hidden = !variant?.[key];
        }
        section.querySelector('[data-stock-status]').textContent = !variant ? unavailableLabel : variant.variantAvailable === 'true' ? section.querySelector('[data-available-label]').textContent : add.dataset.soldOutLabel;
        const shippingNote = section.querySelector('[data-shipping-note]');
        if (shippingNote) shippingNote.hidden = !variant || variant.requiresShipping !== 'true';
        if (variant) {
          qty.min = variant.quantityMin || '1'; qty.step = variant.quantityStep || '1';
          if (variant.quantityMax) qty.max = variant.quantityMax; else qty.removeAttribute('max');
          qty.value = qty.min;
          if (updateUrl && variant.mediaId) move(slides.find(slide => slide.dataset.mediaId === variant.mediaId));
        }
        if (updateUrl) {
          const url = new URL(location.href);
          if (variant) url.searchParams.set('variant',variant.id); else url.searchParams.delete('variant');
          history.replaceState({},'',url);
        }
        error.hidden = true;
        updateAvailability(); updateAddon(); paintButtons();
      }
      form.addEventListener('change', event => {
        if (event.target.hasAttribute('data-option-index')) {
          const chosen = [];
          optionInputs.filter(input => input.checked).forEach(input => { chosen[Number(input.dataset.optionIndex)] = input.value; });
          updateVariant(variants.find(variant => variant.options.every((value,i) => value === chosen[i])),true);
        } else if (event.target === select) {
          const variant = variants.find(item => item.id === select.value);
          optionInputs.forEach(input => { input.checked = variant?.options[Number(input.dataset.optionIndex)] === input.value; });
          updateVariant(variant,true);
        } else if (event.target === addon) updateAddon();
      });
     
      form.addEventListener('submit', async event => {

  const buyNow =
    Boolean(
      event.submitter?.hasAttribute('data-pdp-buy')
    );
  const addingToCart =
    !event.submitter ||
    event.submitter.hasAttribute('data-pdp-add') ||
    event.submitter.hasAttribute('data-pdp-sticky-add') ||
    event.submitter.name === 'add';

  if (!addon && !buyNow) return;
  if (!buyNow && !addingToCart) return;

  event.preventDefault();
  event.stopPropagation();

  if (
    busy ||
    !current ||
    current.variantAvailable !== 'true'
  ) {
    return;
  }


  if (!form.reportValidity()) {
    return;
  }


  const selected =
    addon?.selectedOptions[0];


  if (
    addon?.value &&
    (!selected || selected.disabled)
  ) {
    return;
  }


  const quantity = Math.max(1, Number(qty.value) || 1);
  const gemstoneItem = {
    id: Number(current.id),
    quantity
  };
  const ringInput = form.querySelector('[data-ring-size] input');
  if (ringInput && !ringInput.disabled && ringInput.value.trim()) {
    gemstoneItem.properties = { 'Ring size': ringInput.value.trim() };
  }
  const items = [gemstoneItem];
  if (selected?.value) {
    items.push({
      id: Number(selected.value),
      quantity: 1
    });
  }


  /* =====================================================
     BUY NOW → GOKWIK
  ====================================================== */

  if (buyNow) {

    console.log(
      '[LCA PDP] Buy Now clicked'
    );


    /*
     * IMPORTANT:
     *
     * Tell GoKwik that this is our own button.
     * This prevents GoKwik's generic button scanner
     * from replacing/intercepting it.
     */

    if (buy) {

      buy.dataset.gokwikProcessed =
        'true';

    }


    busy = true;

    error.hidden = true;

    paintButtons();


    /*
     * GoKwik may load after the PDP JS.
     * Wait for onBuyNowClick.
     */

    let attempts = 0;

    const maxAttempts = 50;


    function triggerGoKwik() {

      attempts++;


      if (
        typeof window.onBuyNowClick ===
        'function'
      ) {

        console.log(
          '[LCA PDP] Calling GoKwik Buy Now',
          items
        );


        try {

          window.onBuyNowClick(
            event,
            false,
            items
          );


          console.log(
            '[LCA PDP] GoKwik Buy Now triggered'
          );


          /*
           * GoKwik handles checkout UI,
           * so don't redirect to Shopify /checkout.
           */

          busy = false;

          paintButtons();


        } catch (reason) {

          console.error(
            '[LCA PDP] GoKwik Buy Now error:',
            reason
          );


          error.textContent =
            reason.message ||
            section.querySelector(
              '[data-cart-error-label]'
            ).textContent;


          error.hidden = false;

          busy = false;

          paintButtons();

        }


        return;

      }


      /*
       * GoKwik isn't ready yet.
       */

      if (attempts < maxAttempts) {

        setTimeout(
          triggerGoKwik,
          100
        );

        return;

      }


      console.error(
        '[LCA PDP] GoKwik onBuyNowClick not available'
      );


      error.textContent =
        'Checkout is loading. Please try again.';

      error.hidden = false;

      busy = false;

      paintButtons();

    }


    triggerGoKwik();

    return;

  }


  /* =====================================================
     NORMAL ADD-TO-CART FLOW
  ====================================================== */

  busy = true;

  error.hidden = true;

  paintButtons();


  try {

    const response =
      await fetch(
        section.dataset.addUrl,
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            'Accept':
              'application/json'
          },

          body: JSON.stringify({
            items,
            sections: 'cart-drawer'
          })
        }
      );


    const result =
      await response.json();


    if (!response.ok) {

      throw new Error(
        typeof result.description === 'string'
          ? result.description
          : section.querySelector(
              '[data-cart-error-label]'
            ).textContent
      );

    }


    document.dispatchEvent(new CustomEvent('cart:refresh'));
    if (window.eventBus) {
      if (result.sections && result.sections['cart-drawer']) {
        window.eventBus.emit('update:cart:drawer', result);
      } else {
        window.eventBus.emit('render:cart:drawer');
      }
      window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
    }
    try {
      const cart = await fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(response => response.json());
      if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') window.wetheme.updateCartCount(cart);
    } catch (cartError) {}
    busy = false;
    paintButtons();


  } catch (reason) {

    error.textContent =
      reason.message ||
      section.querySelector(
        '[data-cart-error-label]'
      ).textContent;


    error.hidden = false;

    busy = false;

    paintButtons();

  }

}, true);
      if (optionInputs.length) {
        form.querySelector('[data-option-groups]').hidden = false;
        form.querySelector('[data-native-selector]').hidden = true;
      }
      if (addon) form.querySelector('[data-addon-panel]').hidden = false;
      updateVariant(current,false);
    });
  }
  if (!window.__lcaGemstoneCartBound) {
    window.__lcaGemstoneCartBound = true;
    document.addEventListener('click', event => {
      const button = event.target instanceof Element
        ? event.target.closest('.sticky-add-to-cart, [data-pdp-sticky-add]')
        : null;
      if (!button || button.disabled || button.hasAttribute('data-pdp-buy')) return;
      const section = document.querySelector('[data-lca-product]');
      const form = section?.querySelector('.pdp-product-form');
      if (!section || !form?.querySelector('[data-addon-select]')) return;
      event.preventDefault();
      event.stopPropagation();
      const stickyQty = button.closest('[id^="stickyFooter"]')?.querySelector('[id^="stickyQuantity"]');
      const qtyInput = form.querySelector('[name="quantity"]');
      if (stickyQty && qtyInput && stickyQty.value) qtyInput.value = stickyQty.value;
      const addButton = form.querySelector('[data-pdp-add]');
      if (typeof form.requestSubmit === 'function') {
        if (addButton) form.requestSubmit(addButton);
        else form.requestSubmit();
      }
    }, true);
  }
  setup(document);
  initLooxAutoCarousel();
  document.addEventListener('shopify:section:load',event => setup(event.target));
})();



function initLooxAutoCarousel() {
  const widgets = document.querySelectorAll('loox-snippets-widget');

  widgets.forEach(widget => {
    if (widget.dataset.autoCarouselReady) return;
    widget.dataset.autoCarouselReady = 'true';

    const start = () => {
      const root = widget.shadowRoot || widget;

      const nextButton = root.querySelector(
        'button[aria-label="Scroll right"]'
      );

      if (!nextButton) {
        setTimeout(start, 500);
        return;
      }

      setInterval(() => {
        nextButton.click();
      }, 2000);
    };

    start();
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lca-product-row"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.addEventListener('click', event => {
    const filter = event.target.closest('.lca-editable-row [data-filter]');
    if (!filter) return;
    const section = filter.closest('.lca-editable-row');
    const value = filter.dataset.filter;
    let count = 0;
    section.querySelectorAll('[data-filter]').forEach(button => {
      const active = button === filter;
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    section.querySelectorAll('.product-card').forEach(card => {
      const show = value === 'all' ? card.dataset.bestseller === 'true' : value === 'budget' ? Number(card.dataset.price) < 1000 : card.dataset.categories.split(' ').includes(value);
      card.hidden = !show;
      if (show) count++;
    });
    const status = section.querySelector('[data-filter-status]');
    if (status) status.textContent = count + ' · ' + filter.textContent;
    const empty = section.querySelector('[data-filter-empty]');
    if (empty) empty.hidden = count > 0;
  });
})();

  } catch(e) { console.error(e); }
})();
})();
